import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ToastProvider } from "./components/ui/toast";
import { TooltipProvider } from "./components/ui/tooltip";

// Keep the stale-chunk retry lock through initial route loading. Clearing it
// from an earlier successful shared import can otherwise let a later failed
// page import trigger an endless refresh cycle.
window.setTimeout(() => {
  sessionStorage.removeItem("gerdoo:stale-chunk-reload");
}, 60_000);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TooltipProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </TooltipProvider>
  </StrictMode>,
);
